module.exports = __webpack_public_path__ + "img/60600.836ae22b.jpg";